import ProjectSingle from "../ProjectSingle";

export default class {
  constructor() {}

  ajaxFilter() {
    var gallery = document.getElementById("inspiration-gallery");
    var filterButtons = document.querySelectorAll(".sinlge__filter__item");
    if (!gallery || !filterButtons) return;

    // Check URL param on init and set active filter
    checkUrlParam(filterButtons);

    // Handle filter button click
    filterButtons.forEach(function (button) {
      button.addEventListener("click", function (e) {
        e.preventDefault();

        var filterSlug = this.getAttribute("data-filter");

        // If already active, deselect it (show all)
        if (this.classList.contains("active")) {
          filterButtons.forEach(function (btn) {
            btn.classList.remove("active");
          });
          updateUrl("");
          fetchImages("");
          return;
        }

        // Update active state - select new filter
        filterButtons.forEach(function (btn) {
          btn.classList.remove("active");
        });
        this.classList.add("active");

        updateUrl(filterSlug);
        fetchImages(filterSlug);
      });
    });

    /**
     * Check URL parameter and activate matching filter
     */
    function checkUrlParam(buttons) {
      var urlParams = new URLSearchParams(window.location.search);
      var filterSlug = urlParams.get("type");

      if (filterSlug) {
        buttons.forEach(function (btn) {
          if (btn.getAttribute("data-filter") === filterSlug) {
            btn.classList.add("active");
          } else {
            btn.classList.remove("active");
          }
        });

        // Also fetch filtered images to match URL state
        fetchImages(filterSlug);
      }
    }

    /**
     * Update browser URL with filter parameter
     */
    function updateUrl(filterSlug) {
      var url = new URL(window.location.href);

      if (filterSlug) {
        url.searchParams.set("type", filterSlug);
      } else {
        url.searchParams.delete("type");
      }

      window.history.pushState({ filter: filterSlug }, "", url);
    }

    /**
     * Fetch images via AJAX
     */
    function fetchImages(filterSlug) {
      // Guard: ensure ajax config exists
      if (!window.inspirationAjax || !window.inspirationAjax.ajaxUrl) {
        console.error("inspirationAjax not defined");
        return;
      }
      gallery.classList.add("loading");
      gallery.style.transition = "opacity 0.2s ease";
      gallery.style.opacity = "0.5";

      var formData = new FormData();
      formData.append("action", "inspiration_filter");
      formData.append("nonce", window.inspirationAjax.nonce);
      formData.append("filter", filterSlug);

      fetch(window.inspirationAjax.ajaxUrl, {
        method: "POST",
        body: formData,
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.success) {
            setTimeout(function () {
              gallery.innerHTML = data.data.html;
              gallery.style.opacity = "1";

              // Reinit ProjectSingle for new images
              if (window.projectSingleInstance) {
                window.projectSingleInstance.destroy();
                window.projectSingleInstance = null;
              }
              window.projectSingleInstance = new ProjectSingle();
              window.projectSingleInstance.mobileDropDown();
              window.projectSingleInstance.lightHouseToggle();
              window.projectSingleInstance.bindKeyboardControls();
              window.projectSingleInstance.handleProjectNameHeader();
            }, 200);
          } else {
            console.error("Filter error:", data.data);
            gallery.style.opacity = "1";
          }
        })
        .catch(function (error) {
          console.error("AJAX error:", error);
          gallery.style.opacity = "1";
        })
        .finally(function () {
          gallery.classList.remove("loading");
        });
    }

    // Handle browser back/forward buttons
    window.addEventListener("popstate", function (e) {
      var urlParams = new URLSearchParams(window.location.search);
      var filterSlug = urlParams.get("type") || "";

      filterButtons.forEach(function (btn) {
        btn.classList.remove("active");
        if (filterSlug && btn.getAttribute("data-filter") === filterSlug) {
          btn.classList.add("active");
        }
      });

      fetchImages(filterSlug);
    });
  }
}
